var Acre = "아크레";
var Alagoas = "알라고아스";
var Amazonas = "아마소나스";
var Bahia = "바이아";
var Pernambuco = "페르남부쿠";
var Roraima = "호라이마";
var Sergipe = "세르지피";
var Tocantins = "토칸칭스";
var PTStates = {
	Acre: Acre,
	Alagoas: Alagoas,
	"Amapá": "아마파",
	Amazonas: Amazonas,
	Bahia: Bahia,
	"Ceará": "세아라",
	"Federal District": "연방구",
	"Espírito Santo": "이스피리투산투",
	"Goiás": "고이아스",
	"Maranhão": "마라냥",
	"Mato Grosso": "마투그로수",
	"Mato Grosso do Sul": "마투그로수두술",
	"Minas Gerais": "미나스제라이스",
	"Pará": "파라",
	"Paraíba": "파라이바",
	"Paraná": "파라나",
	Pernambuco: Pernambuco,
	"Piauí": "피아우이",
	"Rio de Janeiro": "리우데자네이루",
	"Rio Grande do Norte": "히우그란지두노르치",
	"Rio Grande do Sul": "히우그란지두술",
	"Rondônia": "혼도니아",
	Roraima: Roraima,
	"Santa Catarina": "산타카타리나",
	"São Paulo": "상파울루",
	Sergipe: Sergipe,
	Tocantins: Tocantins
};

export { Acre, Alagoas, Amazonas, Bahia, Pernambuco, Roraima, Sergipe, Tocantins, PTStates as default };
